module.exports = __webpack_public_path__ + "static/media/brand-refresh-Plus.271c88c8.svg";